// @noflow
import type { Language } from '@/packs/localisation'
import { format as formatDate } from 'date-fns'
import i18next from 'i18next'

import { localeToDateLocale } from '@/utils/countryCodeHelper'

import { Code } from '@/shared_types/rails_models/shipping_countries'

import { TabName } from './TestimonialsTrustpilot'

type CardContentProps = {
  img: string | null
  name: string
  date: string
  url: string
  category: TabName
  copy: string
}[]

const getInitials = (str: string): string => {
  if (str.trim().split(/\s+/).length === 1) return str.slice(0, 2).toUpperCase()
  else
    return str
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase())
      .join('')
}

const formattedDate = (date: string, shippingCountryCode: Code): string => {
  const dateLocale = localeToDateLocale(
    shippingCountryCode,
    i18next.language as Language
  )
  return formatDate(new Date(date), 'MMM yyyy', {
    locale: dateLocale
  })
}

const cardContentButternut = (shippingCountryCode: Code): CardContentProps => {
  return [
    {
      img: 'category-1-card-1-img',
      name: 'Caroline Pratten',
      date: formattedDate('2025-03', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67db01b8f2b06bff7bb7e335',
      category: 'category_1',
      copy: 'phase_2.testimonials.categories.category_1.cards.card_1'
    },
    {
      img: null,
      name: 'Lynne R',
      date: formattedDate('2025-05', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/681c9e167eba8da97bdd4807',
      category: 'category_1',
      copy: 'phase_2.testimonials.categories.category_1.cards.card_2'
    },
    {
      img: null,
      name: 'Kay Braithwaite',
      date: formattedDate('2025-02', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/680a3272a0281b2a37c7b989',
      category: 'category_1',
      copy: 'phase_2.testimonials.categories.category_1.cards.card_3'
    },
    {
      img: 'category-2-card-1-img',
      name: 'Lyn',
      date: formattedDate('2025-04', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/6826104d52016a1617464318',
      category: 'category_2',
      copy: 'phase_2.testimonials.categories.category_2.cards.card_1'
    },
    {
      img: 'category-2-card-2-img',
      name: 'Shelly Chambers',
      date: formattedDate('2025-05', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/681b9192c6476a29725d2a0b',
      category: 'category_2',
      copy: 'phase_2.testimonials.categories.category_2.cards.card_2'
    },
    {
      img: null,
      name: 'Sarah',
      date: formattedDate('2025-02', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/682b838e6c4dd9b2c61ddd09',
      category: 'category_2',
      copy: 'phase_2.testimonials.categories.category_2.cards.card_3'
    },
    {
      img: 'category-3-card-1-img',
      name: 'Gemma Fallon',
      date: formattedDate('2025-03', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67e993b963fb46addf5eb2a8',
      category: 'category_3',
      copy: 'phase_2.testimonials.categories.category_3.cards.card_1'
    },
    {
      img: 'category-3-card-2-img',
      name: 'P Brown',
      date: formattedDate('2025-03', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67e05b88e089badc9addc03f',
      category: 'category_3',
      copy: 'phase_2.testimonials.categories.category_3.cards.card_2'
    },
    {
      img: 'category-3-card-3-img',
      name: 'Sarah Shoebridge',
      date: formattedDate('2025-04', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/680a0da5756dbd2de8ec23bd',
      category: 'category_3',
      copy: 'phase_2.testimonials.categories.category_3.cards.card_3'
    },
    {
      img: 'category-4-card-1-img',
      name: 'Kat Bell',
      date: formattedDate('2024-11', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67446fd054ede8f255b46b9b',
      category: 'category_4',
      copy: 'phase_2.testimonials.categories.category_4.cards.card_1'
    },
    {
      img: 'category-4-card-2-img',
      name: 'Alexander Cook',
      date: formattedDate('2025-05', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/681e1e3537d01f1896493030',
      category: 'category_4',
      copy: 'phase_2.testimonials.categories.category_4.cards.card_2'
    },
    {
      img: null,
      name: 'JN',
      date: formattedDate('2025-04', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/680925728059f9ffc8921348',
      category: 'category_4',
      copy: 'phase_2.testimonials.categories.category_4.cards.card_3'
    },
    {
      img: 'category-5-card-1-img',
      name: 'Gemma Hopley',
      date: formattedDate('2025-01', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67781f05ef2d64e7b659933e',
      category: 'category_5',
      copy: 'phase_2.testimonials.categories.category_5.cards.card_1'
    },
    {
      img: null,
      name: 'Kathryn Howard',
      date: formattedDate('2025-03', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67d71a1c5dd1632fe94563e5',
      category: 'category_5',
      copy: 'phase_2.testimonials.categories.category_5.cards.card_2'
    },
    {
      img: null,
      name: 'Julianna',
      date: formattedDate('2025-01', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/6788ed37aca8f87b259a160e',
      category: 'category_5',
      copy: 'phase_2.testimonials.categories.category_5.cards.card_3'
    }
  ]
}

const cardContentPsiBufet = (shippingCountryCode: Code): CardContentProps => {
  return [
    {
      img: 'category-1-card-1-img',
      name: 'Aldona Sypniewska',
      date: formattedDate('2025-05', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/682762b3f3ee9e7076edf413',
      category: 'category_1',
      copy: 'phase_2.testimonials.categories.category_1.cards.card_1'
    },
    {
      img: 'category-1-card-2-img',
      name: 'Magda Dzieduszycka',
      date: formattedDate('2025-05', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/6824b16440a1cb29300cc042',
      category: 'category_1',
      copy: 'phase_2.testimonials.categories.category_1.cards.card_2'
    },
    {
      img: null,
      name: 'Dominika',
      date: formattedDate('2025-05', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/6825de6c51302c50547f1daf',
      category: 'category_1',
      copy: 'phase_2.testimonials.categories.category_1.cards.card_3'
    },
    {
      img: 'category-2-card-1-img',
      name: 'Ola Koziarska',
      date: formattedDate('2025-05', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/682aed6a174ee046758955b8',
      category: 'category_2',
      copy: 'phase_2.testimonials.categories.category_2.cards.card_1'
    },
    {
      img: 'category-2-card-2-img',
      name: 'Gabriela Bojanowska',
      date: formattedDate('2025-04', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67f8020974e2987a8a8298b9',
      category: 'category_2',
      copy: 'phase_2.testimonials.categories.category_2.cards.card_2'
    },
    {
      img: null,
      name: 'Jolanta Ziętkiewicz',
      date: formattedDate('2025-05', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/68283f155c682f7e93381c7f',
      category: 'category_2',
      copy: 'phase_2.testimonials.categories.category_2.cards.card_3'
    },
    {
      img: null,
      name: 'Evelynek',
      date: formattedDate('2025-03', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67f546e57dfdcef0b8442629',
      category: 'category_3',
      copy: 'phase_2.testimonials.categories.category_3.cards.card_1'
    },
    {
      img: null,
      name: 'Paulina',
      date: formattedDate('2025-02', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67a4f7bfbe8116b3870c965b',
      category: 'category_3',
      copy: 'phase_2.testimonials.categories.category_3.cards.card_2'
    },
    {
      img: null,
      name: 'phase_2.testimonials.categories.category_3.cards.card_3.name',
      date: formattedDate('2025-01', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/6797a07f585836ed3ff85eb1',
      category: 'category_3',
      copy: 'phase_2.testimonials.categories.category_3.cards.card_3'
    },
    {
      img: null,
      name: 'Felis Polosatis',
      date: formattedDate('2025-04', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67f7f36305c65a17476b5c06',
      category: 'category_4',
      copy: 'phase_2.testimonials.categories.category_4.cards.card_1'
    },
    {
      img: null,
      name: 'Gosia',
      date: formattedDate('2025-05', shippingCountryCode),
      url: 'https://uk.trustpilot.com/reviews/681df585030f856f499fbfcc',
      category: 'category_4',
      copy: 'phase_2.testimonials.categories.category_4.cards.card_2'
    },
    {
      img: null,
      name: 'Waldemar',
      date: formattedDate('2025-04', shippingCountryCode),
      url: 'https://pl.trustpilot.com/reviews/67f814153a1622d43e727750',
      category: 'category_4',
      copy: 'phase_2.testimonials.categories.category_4.cards.card_3'
    },
    {
      img: 'category-5-card-1-img',
      name: 'Mirosława Zart-Buszka',
      date: formattedDate('2024-11', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/672d37a19e545f0b768bd0db',
      category: 'category_5',
      copy: 'phase_2.testimonials.categories.category_5.cards.card_1'
    },
    {
      img: null,
      name: 'Kamil',
      date: formattedDate('2025-03', shippingCountryCode),
      url: 'https://www.trustpilot.com/reviews/67d304e998538517f3406097',
      category: 'category_5',
      copy: 'phase_2.testimonials.categories.category_5.cards.card_2'
    },
    {
      img: null,
      name: 'Waldemar',
      date: formattedDate('2025-04', shippingCountryCode),
      url: 'https://pl.trustpilot.com/reviews/67f814153a1622d43e727750',
      category: 'category_5',
      copy: 'phase_2.testimonials.categories.category_5.cards.card_3'
    }
  ]
}

const cardContent = (
  isPsibufet: boolean,
  shippingCountryCode: Code
): CardContentProps => {
  if (isPsibufet) {
    return cardContentPsiBufet(shippingCountryCode)
  } else {
    return cardContentButternut(shippingCountryCode)
  }
}

export { cardContent, getInitials, formattedDate }
